export default "__VITE_PUBLIC_ASSET__27268036__"